import "./FileUploadStyle.scss";
import { IJSLVNode, IJSLComponent, refresh } from "jsl-render";
import Axios from "axios";
import { mapUrl } from "../../helper/mapUrl";
import { DialogComponent, LoadingComponent, StackPanelComponent } from "jsl-ui";
import { AjaxController } from "../../ajax/AjaxController";
import { BCSPjmObjekte } from "../../ajax/types/BCSPjmObjekte";
import { BCSPjmProjektePositionen } from "../../ajax/types/BCSPjmProjektePositionen";

export class FileUploadComponent implements IJSLComponent {

  private fileNames: string[] = [];
  private oldFiles: string[] = [];
  private fileCount = 0;
  private content: IJSLVNode = <div></div>;
  private textarea_content = "";
  private allowedExtensions = ".jpg, .jpeg, .png, .mp4, .mov";
  private isLoading = false;

  public constructor(private Objekt: BCSPjmObjekte, private ProjektePositionen: BCSPjmProjektePositionen, private token: string) {
    this.init();
  }

  public render(): IJSLVNode {
    const maxDateigroesse = "max. 300MB";
    return !this.isLoading ? <div class="file-upload-comp">
      <table class="box-input">
        <tr>
          {new StackPanelComponent([
            <td style="text-align: left">
              <label for="file">
                <strong>Wähle eine Datei aus: </strong>
                <div style="font-size: 0.9em;text-align: center">
                  {this.allowedExtensions} - {maxDateigroesse}
                </div>
              </label>
            </td>,
            <td>
              <input type="file" id="filesToUpload" style="position: absolute; top: -10000px;" multiple change={(e, node: IJSLVNode) => {
                const el = node.dom as HTMLInputElement;
                this.fileNames = [];
                for (let i = 0; i < el.files.length; i++) {
                  this.fileNames.push(el.files[i].name);
                }
                this.fileCount = el.files.length;
              }} />
              <button class={this.fileCount > 0 ? "has-files jsl-button" : "jsl-button"}
                dragenter={(e) => { e.preventDefault(); e.target.classList.add("drag-over"); }}
                dragover={(e) => e.preventDefault()}
                dragleave={(e) => { e.preventDefault(); e.target.classList.remove("drag-over"); }}
                drop={(e) => {
                  e.preventDefault();
                  e.target.classList.remove("drag-over");
                  const droppedFiles = e.dataTransfer?.files;
                  if (droppedFiles != null) {
                    const el = (document.querySelector("#filesToUpload") as HTMLInputElement);
                    el.files = droppedFiles;
                    this.fileNames = [];
                    for (let i = 0; i < el.files.length; i++) {
                      this.fileNames.push(el.files[i].name);
                    }
                    this.fileCount = el.files.length;
                  } else {
                    this.fileNames = [];
                    this.fileCount = 0;
                  }
                }
                }
                click={() => {
                  const el = (document.querySelector("#filesToUpload") as HTMLInputElement);
                  el.click();
                }}>Datei auswählen / drag &amp; drop</button>
              <span id="file-count" style="padding-left: 0.7vw">({this.fileCount})</span><br />
              {this.oldFiles == undefined ? <ul></ul> :
                <div><h3>Uploaded Files</h3>
                  <ul class="data-list">
                    {this.oldFiles.map((file) =>
                      <li><span style="min-height: 1.5rem;"><img style="max-height: 1.2rem; padding-right: 0.5rem;" src={mapUrl("Ajax/GetDownloadImage/Datei")} /><span>{file}</span></span></li>
                    )}
                  </ul></div>
              }
              {this.fileNames == undefined || this.fileCount == 0 ? <div></div> :
                <div><h3>New Files</h3>
                  <ul class="data-list">
                    {this.fileNames.map((f) =>
                      <li>
                        {new StackPanelComponent([
                          <span style="min-height: 1.5rem;"><img style="max-height: 1.2rem; padding-right: 0.5rem;" src={mapUrl("Ajax/GetDownloadImage/Datei")} /><span style="max-width: 9.5rem; overflow: hidden; display: inline-block;">{f}</span></span>,
                          <div class="click-delete" click={() => {
                            const dt = new DataTransfer();
                            this.fileNames = [];
                            const el = (document.querySelector("#filesToUpload") as HTMLInputElement);
                            const files = el.files;
                            for (let i = 0; i < files.length; i++) {
                              if (files[i].name !== f) {
                                dt.items.add(files[i]);
                                this.fileNames.push(files[i].name);
                              }
                            }
                            el.files = dt.files;
                            this.fileCount = el.files.length;
                          }}><img style="max-height: 1.2rem; padding-right: 0.5rem; padding-left: 0.5rem;" src={mapUrl("Ajax/GetDownloadImage/Delete")} /></div>
                        ], {
                          responsive: false,
                          sizes: ["90%", "*"],
                        })}
                      </li>
                    )}
                  </ul>
                </div>}
            </td>], {
            responsive: true,
            sizes: ["30%", "*"],
            style: "min-height: 5rem; max-height: 25rem; overflow: auto"
          })}
        </tr>
        <tr style="height: 6rem">
          {new StackPanelComponent([
            <td style="text-align: left">
              <label for="comment_field">Kommentare: </label>
            </td>,
            <td>
              <textarea class="txtarea" id="comment_field" style="font-size: 0.8em" rows="10" cols="60" form="box" change={() => {
                this.textarea_content = (document.getElementById("comment_field") as HTMLInputElement).value;
              }}></textarea>
              <br />
              <button class="jsl-button" style="margin-top: 0.6rem;" click={async () => {
                let content;
                this.upload();
              }}>Speichern</button>
            </td>], {
            responsive: true,
            sizes: ["30%", "*"]
          })}
        </tr>
      </table>
    </div> : <div>{new LoadingComponent()}</div>;
  }

  private init() {
    AjaxController.GetFilesToProjektPosID(this.ProjektePositionen.ProjektPosID, this.token).then((values) => {
      for (const val of values) {
        this.oldFiles.push(val.SourceFile);
      }
      refresh();
    });
    refresh();
  }

  private shiftLeft(files: FileList, startIdx: number, endIdx: number): void {
    for (let i = startIdx; i < endIdx - 1; i++) {
      files[i] = files[i + 1];
    }
    files[endIdx - 1] = undefined;
  }

  private async upload() {

    const el = (document.querySelector("#filesToUpload") as HTMLInputElement);
    const files = el.files;
    let upload_successful = true;
    if (files.length > 0) {
      const imgformData = new FormData();
      for (let i = 0; i < files.length; i++) {
        imgformData.append("files", files[i]);
      }
      this.isLoading = true;
      refresh();
      await Axios.post(mapUrl("Ajax/AddFiles?Objektnummer=") + this.Objekt.Objektnummer + "&ProPosID=" + this.ProjektePositionen.ProjektPosID + "&Token=" + this.token, imgformData, {}).then((result) => {
        if (result.data && result.data === "OK") {
          this.fileNames = [];
          this.fileCount = 0;
          refresh();
          this.upload_worked();
        } else {
          upload_successful = false;
          this.content = <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center">
            <img style="max-height: 1.5rem; max-height: 1.5rem" src={mapUrl("Ajax/GetDownloadImage/Delete")} />
            &nbsp;Datei/en konnten
            <span style="font-weight: bold; color: red"> nicht </span>
            hochgeladen werden! Erlaubte Dateiendungen sind: {this.allowedExtensions}</div>;
          this.upload_failed();
        }
        this.isLoading = false;
        refresh();
      }).catch((e) => {
        upload_successful = false;
        this.content = <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center">
          <img style="max-height: 1.5rem; max-height: 1.5rem" src={mapUrl("Ajax/GetDownloadImage/Delete")} />
          &nbsp;Datei/en konnten
          <span style="font-weight: bold; color: red"> nicht </span>
          hochgeladen werden! Erlaubte Dateiendungen sind: {this.allowedExtensions}</div>;
        this.upload_failed();
        this.isLoading = false;
        refresh();
      });
    } else {
      upload_successful = false;
      this.content = <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center;">
        <div style="margin: 0.4rem"><img style="max-height: 1.5rem; max-height: 1.5rem; margin:auto" src={mapUrl("Ajax/GetDownloadImage/Delete")} />
          &nbsp;Datei/en konnten
          <span style="font-weight: bold; color: red"> nicht </span>
          hochgeladen werden! </div>
        <div style="margin: 0.4rem"><strong> Keine </strong> Dateien ausgewählt</div></div>;
      this.upload_failed();
    }
    if (this.textarea_content !== "" && upload_successful) {
      AjaxController.AddComment(this.ProjektePositionen.ProjektPosID, this.textarea_content, this.token).then(() => {
        //result ?
        const doc = (document.getElementById("comment_field") as HTMLInputElement);
        if (doc) {
          doc.value = "";
        }
        //   : alert("Kommentar konnte nicht gespeichert werden");
        this.textarea_content = "";
      }).catch((e) => {
        console.log(e);
        alert("Error: Kommentar konnte nicht gespeichert werden");
      });
    }
  }

  private upload_worked() {
    // AjaxController.SetRepStatus(RepStatusEnum.KaufbelegFreigeben, this.ProjektePositionen.ProjektPosID).then(() => {
    DialogComponent.show({
      content: <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center">
        <img style="max-height: 1.5rem; max-height: 1.5rem" src={mapUrl("Ajax/GetDownloadImage/Check")} />
        &nbsp;Datei/en
        <span style="font-weight: bold; color: green"> erfolgreich </span>
        hochgeladen!</div>,
      footer: <div>{DialogComponent.Ok(() => {
        location.reload();
      })}</div>,
      header: <div><strong>Upload erfolgreich</strong></div>,
      maxHeight: "20vh",
      maxWidth: "85vw",
      minHeight: "5vh",
      minWidth: "20vw",
    });
    // });
  }

  private upload_failed() {
    DialogComponent.show({
      content: this.content,
      footer: <div>{DialogComponent.Ok(() => {
        //location.reload();
      })}</div>,
      header: <div><strong>Upload nicht erfolgreich!</strong></div>,
      maxHeight: "10rem",
      maxWidth: "30rem",
      minHeight: "6rem",
      minWidth: "20rem",
    });
  }
}
